import { render, staticRenderFns } from "./ToDoCardEdit.vue?vue&type=template&id=1a4d7514&scoped=true"
import script from "./ToDoCardEdit.vue?vue&type=script&lang=js"
export * from "./ToDoCardEdit.vue?vue&type=script&lang=js"
import style0 from "./ToDoCardEdit.vue?vue&type=style&index=0&id=1a4d7514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d7514",
  null
  
)

export default component.exports